module.exports = __webpack_public_path__ + "static/media/arrow-up.e244e084.svg";